import { apiClient } from "../config";

async function editRoleEditable(id: any, data: any) {
  const url = `/admin/roles/${id}/editable`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editRoleEditable;
